// extracted by mini-css-extract-plugin
module.exports = {"SectionFour":"SectionFour_SectionFour__3VHBM","companylogo":"SectionFour_companylogo__m7rSv"};